module.exports = __webpack_public_path__ + "static/media/student-blue.f7fd3026.svg";